const cookieName = "lastSeenNotificationId";
const storedId = getCookie(cookieName);

function storeToasterCookie(notificationId, daysToExpire=10) {
    storedId.push(notificationId);
    const date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + JSON.stringify(storedId) + "; expires=" + date.toGMTString();
}

function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().match(/-?\d+/g).map(number => parseInt(number));
    return [-1];
}

export { getCookie, storeToasterCookie , cookieName }
